module.exports = __webpack_public_path__ + "media/assets/certification_page/myp-a4ea6ff45d2358362d7009744a9c292ffd41833a7da2f5cb370b4155f0bfbe45.svg";